var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"lista-de-caixas"},_vm._l((_vm.promocoesSemelhantes),function(item){return _c('div',{key:item.id},[_c('box',{attrs:{"box":item}})],1)}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center mr-5 pb-2 pb-md-0"},[_c('h4',{staticClass:"font-weight-bold mb-0 tituloPagina"},[_vm._v("\n      PROMOÇÕES RECOMENDADAS\n    ")])])
}]

export { render, staticRenderFns }